import { SimpleTableHeader, IconArrowSortDownward, IconArrowSortUpDown, IconArrowSortUpward } from 'cdk-radial';
import styled from 'styled-components';

const sortIcons = {
  down: <IconArrowSortDownward />,
  none: <IconArrowSortUpDown />,
  up: <IconArrowSortUpward />,
} as any;

export const SimpleTableHeaderWithSort = styled(
  ({ align = 'left', children, className, onClick, sortActive, sortDirection }) => {
    const sortIcon = sortActive ? sortIcons[sortDirection] : sortIcons.none;
    return (
      <SimpleTableHeader className={`${className} ${sortActive ? `sort ${sortDirection}` : ''}`} onClick={onClick}>
        <div>
          {align === 'right' && sortIcon} {children} {align === 'left' && sortIcon}
        </div>
      </SimpleTableHeader>
    );
  }
)`
  div {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: ${({ align }) => (align === 'right' ? 'flex-end' : 'flex-start')};
  }
  .sortIcon {
  }
  :hover {
    cursor: pointer;
    svg {
      opacity: 1;
    }
  }
  svg {
    opacity: ${({ sortActive }) => (sortActive ? '1' : '0')};
    width: 16px;
    height: 16px;
  }
  text-align: ${({ align }) => align};
`;